module.exports = __webpack_public_path__ + "static/media/JosephWalker-resume.d32ea627.pdf";